import React from "react";
import menuStyles from "./menubutton.module.css";

function MenuButton() {
  return (
    <div className={menuStyles.menuButtonWrap}>
      <input type="checkbox" id="menu_checkbox" />
      <label for="menu_checkbox">
        <div></div>
        <div></div>
        <div></div>
      </label>
    </div>
  );
}

export default MenuButton;
